export { default } from './OutlineNavigator';
